import { createRoot } from 'react-dom/client'
import React from 'react'
import './index.css'
import App from './App'

createRoot(document.querySelector('#root')).render(
  <>
    <App />
    </>
)